import Glide from "@glidejs/glide";

const $glide_featured = document.querySelector(".glide--featured");
if ($glide_featured !== null) {
	new Glide($glide_featured, {
		type: "carousel",
		startAt: 0,
		perView: 3,
		disabled: true,
		breakpoints: {
			780: {
				type: "slider",
				perView: 1,
			},
		},
	}).mount();
}

const $glide_global = document.querySelector(".glide--global");
if ($glide_global !== null) {
	new Glide($glide_global, {
		type: "slider",
		startAt: 0,
		perView: 3,
		disabled: true,
		peek: {
			before: 0,
			after: 150,
		},
		breakpoints: {
			780: {
				perView: 1,
				peek: {
					before: 0,
					after: 80,
				},
			},
		},
	}).mount();
}

document.addEventListener("DOMContentLoaded", function() {
    const $glide_refrence = document.querySelector(".glide--refrence");
    const glideTrack = document.querySelector('.glide.glide--refrence');
    const carouselSpeed = glideTrack.dataset.carouselSpeed;

    if ($glide_refrence !== null) {
        new Glide($glide_refrence, {
            type: "carousel",
            animationDuration: parseInt(carouselSpeed),
            autoplay: 2000,
            startAt: 0,
            perView: 3,
            breakpoints: {
                780: {
                    perView: 1,
                    autoplay: false,
                },
                1190: {
                    perView: 2,
                }
            },
        }).mount();
    }
});


const $glide_slider_desktop = document.querySelector(".glide--slider-desktop");
if ($glide_slider_desktop !== null) {
	const $glide_slider_desktop_elements = document.querySelector(
		".glide--slider-desktop .glide__slides"
	);
	new Glide($glide_slider_desktop, {
		type: "carousel",
		autoplay:
			$glide_slider_desktop_elements.childElementCount >= 2 ? 2000 : false,
		hoverpause: true,
		startAt: 0,
		focusAt: "center",
		perView: 1,
		gap: 0,
	}).mount();
}

const $glide_slider_mobile = document.querySelector(".glide--slider-mobile");
if ($glide_slider_mobile !== null) {
	const $glide_slider_mobile_elements = document.querySelector(
		".glide--slider-mobile .glide__slides"
	);
	new Glide($glide_slider_mobile, {
		type: "carousel",
		autoplay:
			$glide_slider_mobile_elements.childElementCount >= 2 ? 2000 : false,
		hoverpause: true,
		startAt: 0,
		focusAt: "center",
		perView: 1,
		gap: 0,
	}).mount();
}

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
function debounce(func, wait, immediate) {
	var timeout;
	return function () {
		var context = this,
			args = arguments;
		var later = function () {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
}
const $glide_mobile = document.querySelector(".glide--mobile");

var myEfficientFn = debounce(function () {
	let $width = window.innerWidth;
	if ($width < 768 && $glide_mobile !== null) {
		let gildeMobile = new Glide($glide_mobile, {
			breakpoints: {
				768: {
					type: "slider",
					startAt: 0,
					perView: 1,
				},
			},
		}).mount();
	}
	// All the taxing stuff you do
}, 250);

window.addEventListener("resize", myEfficientFn);
window.addEventListener("DOMContentLoaded", (event) => {
	let $width_init = window.innerWidth;
	if ($width_init < 768 && $glide_mobile !== null) {
		new Glide($glide_mobile, {
			breakpoints: {
				768: {
					type: "slider",
					startAt: 0,
					perView: 1,
				},
			},
		}).mount();
	}
});
